var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questions-answers__item-text",domProps:{"innerHTML":_vm._s(_vm.answerText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }